import React from "react";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";

const PrivacyPolicyPage = () => {
	return (
		<div style={{ margin: 0, padding: 0, background: "#F8FAFC" }}>
			<div
				style={{
					width: "100%",
					minHeight: "100vh",
					background: "#F8FAFC",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Header />

				<section className="w-full flex justify-center px-4 py-10 sm:px-6 lg:px-8">
					<div className="w-full max-w-[1204px]">
						<article className="rounded-[18px] border border-[#e5e9f2] bg-white p-6 shadow-[0_10px_24px_rgba(15,23,42,0.04)] sm:p-8 lg:p-10">
							<div className="flex flex-col gap-10">
								{/* Title */}
								<div>
									<h1 className="m-0 text-[28px] font-bold leading-tight text-[#0f172a]">
										Privacy Policy
									</h1>
								</div>

								{/* Intro paragraphs */}
								<div className="flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
									<p className="m-0">
										This document sets forth the Privacy
										Policy associated with the use of the
										data to be collected by the National
										Information and Communication Technology
										Company Limited (iGovTT) for processing
										by the VerifyTT solution. In all
										respects, this Policy shall be subject
										to the provisions of the Data Protection
										Act, Chapter. 22:04 of the Laws of the
										Republic of Trinidad and Tobago or any
										statutory modification or re-enactment
										thereof.
									</p>
									<p className="m-0">
										The Privacy Policy for the VerifyTT
										website sets out iGovTT's prevailing
										principles concerning the privacy of the
										personal information associated with
										individuals who access the platform.
									</p>
									<p className="m-0">
										The collection of personal information
										shall be treated as confidential to
										protect the rights and privacy of the
										user and the user's related parties. The
										following personal information has been
										classified in accordance with the Data
										Protection Act, Chapter. 22:04, as any
										information about an identifiable
										individual which is recorded in any form
										including, but not limited to: -
									</p>
									<ul className="m-0 list-disc pl-6 text-[16px] font-normal leading-6 text-[#334155] marker:text-[#334155]">
										<li className="mb-1">
											Information relating to the race,
											nationality or ethnic origin,
											religion, age or marital status of
											the individual;
										</li>
										<li className="mb-1">
											Information relating to the
											education, medical, criminal, or
											employment history and earrings of
											the individual;
										</li>
										<li className="mb-1">
											The address and telephone contact
											number of the individual;
										</li>
										<li className="mb-1">
											Any identifying number, symbol or
											other particular designed to
											identify the individual;
										</li>
									</ul>
									<p className="m-0">
										This policy regarding the privacy of any
										personally identifiable information you
										provide online covers four (4) main
										areas: Awareness, Choice, Security, and
										Oversight.
									</p>
								</div>

								{/* Awareness */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										Awareness
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											iGovTT provides this Privacy Policy,
											which is to be read together with
											its Terms and Conditions, to create
											awareness among users of its
											practices and the choices which a
											user can make about the way his
											information is collected and used.
											Therefore, in promoting easy access
											to the Privacy Policy and Terms and
											Conditions, iGovTT makes these
											available on our homepage and at the
											bottom of every
											https://VerifyTT.gov.tt / web page.
										</p>
									</div>
								</section>

								{/* What we collect */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										What We Collect
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											When you utilise the VerifyTT
											website, iGovTT will be required to
											be informed of the following
											personal information:
										</p>
										<ul className="m-0 list-disc pl-6 text-[16px] font-normal leading-6 text-[#334155] marker:text-[#334155]">
											<li className="mb-1">Name</li>
											<li className="mb-1">
												Residential address and e-mail
												address
											</li>
											<li className="mb-1">
												Telephone numbers
											</li>
											<li className="mb-1">
												Technical Data and Device
												information including but not
												limited to internet protocol
												(IP) address, login data,
												browser type and version,
												browser plug-in types and
												versions, operating system and
												platform
											</li>
											<li className="mb-1">
												Geolocation Information
												including but not limited to
												time zone setting and location
											</li>
											<li className="mb-1">
												Technical Usage Data including
												but not limited to information
												about how you use the website
											</li>
										</ul>
									</div>
								</section>

								{/* How we use it */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										How We Use It
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											For each visitor to access the
											website, the VerifyTT solution also
											collects the following
											non-personally identifiable
											information, including but not
											limited to browser type, version and
											language, operating system, pages
											viewed while browsing the site, page
											access times and referring website
											address. This collected information
											is used solely internally for the
											purpose of troubleshooting, gauging
											visitor traffic and trends.
										</p>

										<div className="overflow-hidden rounded-[12px] border border-[#dce3ef]">
											<table className="w-full border-collapse text-left text-[13px] leading-6 text-[#334155]">
												<thead className="bg-[#111827] text-white">
													<tr>
														<th
															className="px-4 py-3 text-[12px] font-semibold uppercase tracking-[0.06em]"
															style={{
																width: "33%",
															}}
														>
															Purpose/Activity
														</th>
														<th
															className="px-4 py-3 text-[12px] font-semibold uppercase tracking-[0.06em]"
															style={{
																width: "25%",
															}}
														>
															Type of Data
														</th>
														<th className="px-4 py-3 text-[12px] font-semibold uppercase tracking-[0.06em]">
															Lawful basis for
															processing including
															basis of legitimate
															interest
														</th>
													</tr>
												</thead>
												<tbody>
													<tr className="border-t border-[#e2e8f0] bg-white align-top">
														<td className="px-4 py-3 font-bold text-[#0f172a]">
															To register you as a
															new user.
														</td>
														<td className="px-4 py-3">
															a. Identity <br />{" "}
															b. Contact
														</td>
														<td className="px-4 py-3">
															Necessary for
															processing a job
															application request.
														</td>
													</tr>
													<tr className="border-t border-[#e2e8f0] bg-white align-top">
														<td className="px-4 py-3 font-bold text-[#0f172a]">
															To use data
															analytics to improve
															our website,
															products/services,
															customer
															relationships and
															experiences.
														</td>
														<td className="px-4 py-3">
															a. Identity <br />{" "}
															b. Contact <br /> c.
															Technical <br /> d.
															Usage
														</td>
														<td className="px-4 py-3">
															Necessary to keep
															our records updated
															and to study how
															customers use our
															products/services.
															To keep our website
															updated and
															relevant, to develop
															our business and to
															inform our marketing
															strategy.
														</td>
													</tr>
													<tr className="border-t border-[#e2e8f0] bg-white align-top">
														<td className="px-4 py-3 font-bold text-[#0f172a]">
															To administer and
															protect our business
															and this website
															(including
															troubleshooting,
															data analysis,
															testing, system
															maintenance,
															support, reporting
															and hosting of data)
														</td>
														<td className="px-4 py-3">
															a. Identity <br />{" "}
															b. Contact <br /> c.
															Technical
														</td>
														<td className="px-4 py-3">
															Necessary for
															running our
															business, provision
															of administration
															and IT services,
															network security, to
															prevent fraud.
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</section>

								{/* Who we share it with */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										Who We Share It With
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											iGovTT will not disclose your
											personal identifiable information to
											external parties save and except:
										</p>
										<ul className="m-0 list-disc pl-6 text-[16px] font-normal leading-6 text-[#334155] marker:text-[#334155]">
											<li className="mb-1">
												<span className="font-bold text-[#0f172a]">
													With your consent:{" "}
												</span>
												By clicking the acceptance box,
												you expressly consent to the
												disclosure of your personal
												information to agencies
												nominated by you. This consent
												authorises iGovTT to share your
												information with such nominated
												agencies for the purposes of
												validation and verification.
											</li>
											<li className="mb-1">
												If mandated to do so by any
												applicable law, rule, or
												regulation, or by any judgment,
												order, or decree issued by a
												court or governmental body or
												agency having jurisdiction over
												iGovTT. In such cases iGovTT, if
												possible and permissible under
												applicable law, will promptly
												provide advance written notice
												to you of such disclosure to
												allow you the opportunity to
												seek protective measures or
												other appropriate remedies.
											</li>
										</ul>
									</div>
								</section>

								{/* Choice */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										Choice
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											iGovTT will not use or share the
											personally identifiable information
											provided to it online in ways
											unrelated to the ones described
											above without first informing you
											and also offering you choice.
											Further to this, iGovTT will not use
											or disclose sensitive personal
											information, such as race, religion,
											or political affiliations, without
											your explicit consent.
										</p>
									</div>
								</section>

								{/* Withdrawal of Consent */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										Withdrawal of Consent
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											You have the right to withdraw your
											consent to the collection, use, or
											disclosure of your personal
											information at any time, subject to
											reasonable notice. To withdraw your
											consent, please contact us via{" "}
											<a
												href="https://www.igovtt.tt/contact-us/"
												className="text-[#116DFD] underline hover:text-[#0d56c9]"
											>
												https://www.igovtt.tt/contact-us/
											</a>
											. Please note that withdrawing
											consent may affect our ability to
											provide the services requested by
											you.
										</p>
									</div>
								</section>

								{/* Security */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										How Secure Is Your Personal Information?
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											iGovTT is committed to ensuring the
											security of your information. In
											order to prevent unauthorized access
											or disclosure, maintain data
											accuracy, and ensure the appropriate
											use of information, your data is
											stored in a highly secure
											environment and access is restricted
											to legitimate users. Multiple layers
											of protection are used to guard
											against illegal access to Data, such
											as Network and Application
											Firewalls, Passwords and data
											Encryption.
										</p>
										<p className="m-0">
											iGovTT designs, builds and runs its
											systems to ensure that your data is
											as safe as possible at all stages,
											both while it is processed and when
											it is stored. iGovTT maintains its
											security audit to ensure that the
											application and your information are
											always secure.
										</p>
									</div>
								</section>

								{/* Changes */}
								<section className="scroll-mt-24">
									<h2 className="m-0 text-[16px] tracking-wide font-semibold leading-7 text-[#116DFD]">
										Changes to This Privacy Policy
									</h2>
									<div className="mt-4 flex flex-col gap-3 text-[16px] font-normal leading-7 text-[#333333]">
										<p className="m-0">
											iGovTT reserves the right to make
											amendments to this Privacy Policy.
											If you have any questions about this
											Privacy Policy or would like further
											information, please contact us via{" "}
											<a
												href="https://www.igovtt.tt/contact-us/"
												className="text-[#116DFD] underline hover:text-[#0d56c9]"
											>
												https://www.igovtt.tt/contact-us/
											</a>
										</p>
									</div>
								</section>
							</div>
						</article>
					</div>
				</section>

				<Footer />
			</div>
		</div>
	);
};

export default PrivacyPolicyPage;
